import type { CSSProperties } from 'react';

export const SVG_STYLE: CSSProperties = {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  strokeLinejoin: 'round',
  strokeMiterlimit: '2',
  zIndex: 10000,
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none', // This makes the SVG not block interactions
};

export const PATH_STYLE: CSSProperties = {
  fill: 'rgb(0,0,0)',
  opacity: 0.75,
  pointerEvents: 'auto', // This makes the dark part clickable
  cursor: 'auto',
  transition: 'opacity 150ms ease-out',
};

/** Padding around the highlighted element in the SVG hole (px). Keep in sync with generateSvgPath. */
export const HIGHLIGHT_PADDING = 8;

export const TOOLTIP_OFFSET = 18;
export const DEBOUNCE_DELAY = 300;

export const TOOLTIP_BASE_STYLE: CSSProperties = {
  zIndex: 10001,
  opacity: 1,
  pointerEvents: 'auto',
  background: 'white',
  border: '1px solid #ccc',
  borderRadius: '8px',
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
  maxWidth: 'calc(100vw - 32px)',
  transition: 'opacity 150ms ease-out',
};
